import React from 'react'
import './Notifications.css'
const Notifications = ({users}) => {
    return (
        <>
         <div className='notifications-container'>
            <div className='notifications-box'>
                
                <p>Brad pandit</p>
            </div>
         </div>
        </>
    )
}

export default Notifications
